import React from 'react';
import { Text } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { EmptyContentMenuItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/empty-content/index.tsx';
import { messages } from './messages.tsx';

export function OverviewsEmptyState() {
	const { formatMessage } = useIntl();

	return (
		<EmptyContentMenuItem>
			<Text size="small" align="center" color="color.text.subtlest">
				{formatMessage(messages.noOverviews)}
			</Text>
		</EmptyContentMenuItem>
	);
}
